import PromotionalArticle from '../../resource_models/promotional_article'

export const isLoading = (state) => {
  return state.isCallingAPI
}

export const all = (state) => {
  return state.result.map((id) => new PromotionalArticle(state.entities[id]))
}

export const find = (state) => (id) => {
  return new PromotionalArticle(state.entities[id])
}

export const meta = (state) => {
  return state.meta
}

export const errors = (state) => {
  return state.errors
}
